/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Guide_Stat_Premiere_ValueInputs */

const en_fw_guide_stat_premiere_value = /** @type {(inputs: Fw_Guide_Stat_Premiere_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oct 9`)
};

const zh_fw_guide_stat_premiere_value = /** @type {(inputs: Fw_Guide_Stat_Premiere_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10月9日`)
};

/**
* | output |
* | --- |
* | "Oct 9" |
*
* @param {Fw_Guide_Stat_Premiere_ValueInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_guide_stat_premiere_value = /** @type {((inputs?: Fw_Guide_Stat_Premiere_ValueInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Guide_Stat_Premiere_ValueInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_guide_stat_premiere_value(inputs)
	return zh_fw_guide_stat_premiere_value(inputs)
});
export { fw_guide_stat_premiere_value as "fw.guide.stat.premiere_value" }